import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const TaskExtensionRequestCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `يسأل ${sender?.name} عن تمديد ميعاد تسليم مهمة`
    : `${sender?.name} asks for extension of your Task Deadline`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default TaskExtensionRequestCover
